// Encadré doré uniforme listant les caractéristiques techniques d'un outil/jeu.
// Dimensions identiques d'une carte à l'autre (min-height fixe + largeur pleine).
const LABELS = { fr: "Caractéristiques", en: "Features", es: "Características", nl: "Kenmerken" };

export const ToolSpecs = ({ lang = "fr", items = [], className = "" }) => {
  const label = LABELS[lang] || LABELS.fr;
  return (
    <div
      data-testid="tool-specs"
      className={`rounded-2xl border border-primary/45 bg-primary/[0.05] px-4 py-3.5 min-h-[108px] flex flex-col justify-center ${className}`}
      style={{ boxShadow: "inset 0 0 0 1px hsl(38 90% 55% / 0.14), 0 0 24px -10px hsl(38 90% 55% / 0.45)" }}
    >
      <p className="text-[10px] uppercase tracking-[0.24em] text-primary/75 mb-3">{label}</p>
      <div className="grid grid-cols-3 gap-2.5">
        {items.map((it, i) => {
          const Icon = it.Icon;
          return (
            <div key={i} className="flex flex-col items-center text-center gap-1.5" data-testid={`tool-spec-${i}`}>
              {Icon && <Icon size={16} className="text-primary flex-shrink-0" />}
              <span className="text-[12px] leading-tight text-foreground/75">{it.text}</span>
            </div>
          );
        })}
      </div>
    </div>
  );
};
